import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfigurationService } from "../../../../services/configuration.service";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../../constants/assets.constants";

@Component({
  selector: "mis-list-card-row",
  templateUrl: "./list-card-row.component.html",
  styleUrls: ["./list-card-row.component.scss"]
})
export class ListCardRowComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  isShuttleRequired: boolean;
  showCancellationFilter: boolean;
  onlyParkingBookingEnabled: boolean = false;

  @Input() item: any;
  @Input() dateFormat: any;
  @Input() timeFormat: any;
  @Input() singleShiftOperation = false;
  @Output() action = new EventEmitter(true);

  constructor(public configSvc: ConfigurationService) {}
  ngOnInit(): void {
    this.configSvc.bookingConfigurations.subscribe(res => {
      this.isShuttleRequired = res.isShuttleRequired;
    });
    this.configSvc.configurations.subscribe(res => {
      this.showCancellationFilter = res?.flattenedSettings?.showBookingFilter;
      this.onlyParkingBookingEnabled = !!res?.flattenedSettings?.onlyParkingBookingEnabled
        ? res?.flattenedSettings?.onlyParkingBookingEnabled
        : false;
    });
  }

  checkOnlyParkingEnabled() {
    return this.item.bookingRequestType !== "OFFICE" ? true : !(!!this.onlyParkingBookingEnabled && this.onlyParkingBookingEnabled);
  }
}
